import { render, staticRenderFns } from "./product-filter.vue?vue&type=template&id=06daa83a"
import script from "./product-filter.vue?vue&type=script&lang=js"
export * from "./product-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports